import React from "react";
import { RainfallSettingArray } from "../types/type";

type Props = {
  type: string;
  mode: string;
  settingData: any;
  setSettingData: any;
};

export const SettingTable = (props: Props) => {
  const { type, mode, settingData, setSettingData } = props;
  const settingDataArray = Array.isArray(settingData)
    ? settingData
    : [settingData];
  const keysArray = Object.keys(settingDataArray[0]);
  // 2024/10/17　水位に「28」を入力すると「28.000000000000004」に表示される不具合の修正 del start↓
  // 水位データについて、管理はメートルで表示はセンチメートルにする
  // function adjustRetentionDataUnit(gui_input: number) {
  //   if (type !== "rainfall") {
  //     return gui_input * 0.01;
  //   } else {
  //     return gui_input;
  //   }
  // }
  // 2024/10/17　水位に「28」を入力すると「28.000000000000004」に表示される不具合の修正 del end↑
  function adjustDisplayDataUnit(retention_data: number) {
    if (type !== "rainfall") {
      return retention_data * 100;
    } else {
      return retention_data;
    }
  }
  return (
    <table className="border w-full text-sm text-left text-gray-500 dark:text-gray-400">
      <thead className="text-xs text-gray-700 bg-gray-50 dark:bg-gray-700 dark:text-gray-400 sticky top-0">
        <tr>
          <th scope="col" className="px-6 py-3 text-center">
            日時
          </th>
          <th scope="col" className="px-6 py-3 text-center">
            {type === "rainfall" ? "降雨量（mm/hr）" : "水位(cm)"}
          </th>
          {/* <th scope="col" className="px-6 py-3 text-center">
            センサーID
          </th> */}
        </tr>
      </thead>
      <tbody>
        {settingDataArray.map((data: any, index: number) => {
          return (
            <tr
              key={index}
              className="bg-white dark:bg-gray-800 dark:border-gray-700"
            >
              <td className="border px-2 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                <div className="w-[150px] text-center">
                  {data[keysArray[0]]}
                </div>
              </td>
              <td className="border">
                {mode === "reference" ? (
                  <div className="py-2 px-2 inline-block w-[150px] text-center text-gray-300">
                    {adjustDisplayDataUnit(parseFloat(data[keysArray[1]]))}
                  </div>
                ) : (
                  <input
                    className={`py-2 px-2 inline-block w-[150px] text-center ${
                      data[keysArray[1]] !== undefined &&
                      data[keysArray[1]] !== null &&
                      !Number.isNaN(data[keysArray[1]])
                        ? ""
                        : "bg-red-100"
                    }`}
                    type="text"
                    // 2024/10/17　水位に「28」を入力すると「28.000000000000004」に表示される不具合の修正 del start↓
                    // value={
                    //   data[keysArray[1]] !== undefined &&
                    //   data[keysArray[1]] !== null &&
                    //   !Number.isNaN(data[keysArray[1]])
                    //     ? adjustDisplayDataUnit(parseFloat(data[keysArray[1]]))
                    //     : ""
                    // }
                    // 2024/10/17　水位に「28」を入力すると「28.000000000000004」に表示される不具合の修正 del end↑
                    // 2024/10/17　水位に「28」を入力すると「28.000000000000004」に表示される不具合の修正 add start↓
                    value={
                      data[keysArray[1]] !== undefined &&
                      data[keysArray[1]] !== null &&
                      !Number.isNaN(data[keysArray[1]])
                        ? parseFloat(data[keysArray[1]])
                        : ""
                    }
                    // 2024/10/17　水位に「28」を入力すると「28.000000000000004」に表示される不具合の修正 add end↓
                    onChange={(e) => {
                      setSettingData((prevState: any) =>
                        prevState.map((obj: any, objIndex: number) =>
                          objIndex === index &&
                          /^\d{0,3}(\.\d{0,1})?$/.test(e.target.value)
                            ? {
                                ...obj,
                                // 2024/10/17　水位に「28」を入力すると「28.000000000000004」に表示される不具合の修正 del start↓
                                // [keysArray[1]]: adjustRetentionDataUnit(
                                //   parseFloat(e.target.value)
                                // ),
                                // 2024/10/17　水位に「28」を入力すると「28.000000000000004」に表示される不具合の修正 del end↑
                                // 2024/10/17　水位に「28」を入力すると「28.000000000000004」に表示される不具合の修正 add start↓
                                [keysArray[1]]: parseFloat(e.target.value),
                                // 2024/10/17　水位に「28」を入力すると「28.000000000000004」に表示される不具合の修正 add end↑
                              }
                            : { ...obj }
                        )
                      );
                    }}
                  />
                )}
              </td>
              {/* <td className=" border  px-2 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                <div className="w-[150px] text-center">
                  {data[keysArray[2]]}
                </div>
              </td> */}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
